<div [innerHTML]="htmlContent"></div>
